import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import autobind from "autobind-decorator";
import * as focusManager from "util/focusManager";
import scopeTab from "util/scopeTab";
import { ActionRootContext } from "higher-order/ActionRoot";

class ModalPortal extends React.Component {

    static propTypes = {
        modalKey: PropTypes.string.isRequired,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        hideHeader: PropTypes.bool,
        allowScrollBar: PropTypes.bool,
        shouldCloseOnOverlayClick: PropTypes.bool,
        enableDefaultCloseButton: PropTypes.bool,
        className: PropTypes.string
    }

    static defaultProps = {
        enableDefaultCloseButton: true
    }

    static contextType = ActionRootContext;

    componentDidMount() {
        focusManager.setupScopedFocus(ReactDOM.findDOMNode(this));
        focusManager.markForFocusLater();
        this.refs.dialog.focus();
    }

    componentWillUnmount() {
        focusManager.returnFocus();
        focusManager.teardownScopedFocus();
    }

    close() {
        if (this.props.onClose) {
            this.props.onClose();
        }
        this.context.dispatcher.emit("HIDE_MODAL", { modalKey: this.props.modalKey });
    }

    @autobind
    handleKeyDown(e) {
        if (e.keyCode === 9 /*tab*/) {
            scopeTab(this.refs.dialog, e);
        }
        if (e.keyCode === 27 /*esc*/) {
            if (this.props.enableDefaultCloseButton) {
                this.close();
            }
        }
    }

    @autobind
    handleClickCloseButton(e) {
        e.preventDefault();
        this.close();
    }

    @autobind
    handleClick(e) {
        if (this.props.shouldCloseOnOverlayClick) {
            e.stopPropagation();
        }
    }

    render() {
        return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <div
                ref="dialog"
                className={"modal-dialog " + (this.props.className || "")}
                onClick={this.handleClick}
                onKeyDown={this.handleKeyDown}
                tabIndex="-1"
                role="dialog"
            >
                {!this.props.hideHeader &&
                    <div className="modal-header">
                        {this.props.title}
                        {this.props.enableDefaultCloseButton &&
                            <button className="modal-close-button" title="Close" onClick={this.handleClickCloseButton}>
                                <i className="icon-cancel-thin" />
                            </button>
                        }
                    </div>
                }
                <div className="modal-content">
                    {this.props.children}
                </div>
                {this.props.showFooter &&
                    <div className="modal-footer">
                        {this.props.enableDefaultCloseButton &&
                            <button className="modal-footer-close-button" onClick={this.handleClickCloseButton}>
                                Close
                            </button>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default ModalPortal;
